<template>
    <v-layout >
        <v-flex sm1>
            <!--<v-icon v-if="!tarjetaTokenizada.baja" color="pink">star</v-icon>
            <v-chip v-if="tarjetaTokenizada.baja" small color="grey">baja</v-chip>-->
            <v-icon v-if="tarjetaEditor.activa" color="pink">star</v-icon>
            <v-chip v-if="!tarjetaEditor.activa" small color="grey">baja</v-chip>
        </v-flex>

        <v-flex sm9>
            <div> {{tarjetaTokenizada.emisor}} / {{tarjetaTokenizada.numero}} - Vto. {{tarjetaTokenizada.mesVencimiento}}/{{tarjetaTokenizada.anioVencimiento}}</div>
        </v-flex>
        
        <v-spacer></v-spacer>
        <v-flex sm1>
            <v-tooltip bottom v-if="showEdit">
                <template v-slot:activator="{ on }">
                    <v-btn  icon small v-on="on" @click="editar"> <v-icon color="red lighten-2">edit</v-icon></v-btn>
                </template>
                <span>Editar</span>
            </v-tooltip>  
        </v-flex>
        <v-flex sm1>
             <v-tooltip bottom v-if="showDelete">
                 <template v-slot:activator="{ on }">
                    <v-btn icon small v-on="on" @click="eliminar(tarjetaEditor.id)" v-if="checkCanAccess('ap-puede-anular-cbu')"> <v-icon color="grey">delete</v-icon></v-btn>
                 </template>
                <span>Dar de Baja</span>  
            </v-tooltip>
        </v-flex>
                
        <v-dialog v-model="editModeOn" width="800" persistent>        
            <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">                              
                <v-container fluid grid-list-lg >
                  <v-card-title class="headline" primary-title >Edición de Tarjeta</v-card-title>

                    <v-row align="center" dense>
                        <v-col cols="6">
                            <div class="body-2" > EMISOR: {{tarjetaEditor.emisor}}</div>
                        </v-col>
                         <v-col >
                            <v-switch v-model="tarjetaEditor.activa"
                             label="Activa"
                             v-validate="'required'" 
                             data-vv-name="activa" 
                             :disabled="!checkCanAccess('ap-puede-anular-cbu')" >
                             </v-switch>
                        </v-col> 
                    </v-row>
                    <v-row dense>
                        <v-col >
                            <div class="body-2" >TIPO: {{tarjetaEditor.tipo}}</div>
                        </v-col>
                        <v-col >
                            <div class="body-1" >NUMERO: {{tarjetaEditor.numero}}</div>
                        </v-col>
                        <v-col >
                            <div class="body-1" >VTO: {{tarjetaTokenizada.mesVencimiento}}/{{tarjetaTokenizada.anioVencimiento}}</div>
                        </v-col>
                    </v-row>
                    
                </v-container>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn
                        color="accent"
                        text
                        @click="cancelar()"
                    >
                        Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="confirmarModificacion()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>

         <template v-if="$store.state.debugModeOn">
            Debug Info: <p></p>
            
            Editor: {{tarjetaEditor}}  <p></p>
            Origen: {{tarjetaTokenizada}}  <p></p>
            Validacion: {{resultadoValidacion}}  <p></p>
        </template>

        </v-dialog>
    </v-layout>
</template>

<script>
import Vue from 'vue'
import { http } from '@/axios'
import {  
  mapGetters,
  mapMutations,  
} from 'vuex'

export default {
  data: () => ({
    editModeOn: false, 
    tarjetaCardCredSeleccionada: null,
    tarjetaTokenizada: {},
    tarjetaEditor: {token:'', tokenizadaPorId: 0, activa: true, ultimosDigitos:0, motivoBaja : '',responsableBaja:''},
    resultadoValidacion: {esValido: true},
    tarjetasExistentes: [], 
  }),
  props: {
    value: {
      type: Object,
      required: false
    },

     tarjetasExistentes: {
      type: Array,
      required: false,
    },

    propName:{
        type: String,
        required: false,
        default: ''
    },
    standAloneMode: {
      type: Boolean,
      default: true
    },
    personaId: {
      type: String,
      required: false,
      default: null
    },
    tarjetaSeleccionada: {
      type: Object,
      required: false,
      default: function(){return {}}
    },
    label: {
      type: String,
      default: 'tarjetaTokenizada'
    },
    editMode: {
      type: Boolean,
      default: true
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: true
    },
    setPredeterminado: Function,
  },
  watch:{
   /*'tarjetaEditor.activa' : async function(){
        if( this.editModeOn && this.tarjetaEditor.activa == false){
            this.tarjetaEditor.motivoBaja = await this.$dialog.prompt({
          text: 'Ingrese el Motivo de la Baja', 
          title: 'Confirmar Operación',
          persistent: true // Parece que no funciona...  
            })
        }*/

    'tarjetaEditor.activa' : async function(){
        if( this.editModeOn) {
         if(this.tarjetaEditor.activa == false) {
           this.tarjetaEditor.motivoBaja = await this.$dialog.prompt({
          text: 'Ingrese el Motivo de la Baja', 
          title: 'Confirmar Operación',
          persistent: true // Parece que no funciona...  
            })
         }/*else {

         }*/
           
        }

    },
    'value.tarjetaTokenizada': function(item){      
        console.log('value.tarjetaTokenizada')
        console.log(item)
        this.tarjetaTokenizada = item;    
        this.setTarjeta()
    },
        
  },
  computed:{
    ...mapGetters(['checkCanAccess'])
  },
  created(){
    this.setTarjeta()
  },
  methods: {
      ...mapMutations(["hideActiveSubTask","alertClear", "alertSuccess", "alertWarning", "alertError"]),
      
      setTarjeta(){
          if(this.propName == ''){
            this.tarjetaTokenizada = this.value;
            this.copiarTarjeta(this.value, this.tarjetaEditor); // hago una copia para poder modificarlo asi afectar al original 
          }
          else{
            if(!this.value[this.propName]){ // Si no está cargada, creo la propiedad 
                this.tarjetaTokenizada = {
                    activa: true,
                    emisor: '',
                    numero: '',
                    tipo: '',
                    token: '',
                    ultimosDigitos: '',
                    vencimiento: Date.now(),
                    fechaAlta: Date.now()               
                }

                this.value[this.propName] = this.tarjetaTokenizada
            }
            this.tarjetaTokenizada = this.value[this.propName]
          }          
      },
    copiarTarjeta(source, destination){
        destination.activa = source.activa;
        destination.emisor = source.emisor;
        destination.numero = source.numero;
        destination.tipo = source.tipo;
        destination.token = source.token;
        destination.ultimosDigitos = source.ultimosDigitos;
        destination.vencimiento = source.vencimiento;
        destination.fechaAlta = source.fechaAlta;
        destination.tokenizadaPorId = source.tokenizadaPorId;
        destination.ultimosDigitos = source.ultimosDigitos;
        destination.motivoBaja = source.motivoBaja;
        destination.responsableBaja = source.motivoBaja;
        destination.personaId = source.personaId;
        destination.id = source.id;
      },
      async confirmarModificacion(){
        // valido
        await this.$validator.validateAll()

        if(this.errors.items.length > 0){
            Vue.$log.debug('validation:');
            Vue.$log.debug(this.errors);
            return;
        } 

        //this.copiarTarjeta(this.tarjetaEditor, this.datosTarjeta);
        
        var tarjetaExistente = this.tarjetasExistentes.find(x=>x.id == this.tarjetaTokenizada.id)
        if(tarjetaExistente){
            this.copiarTarjeta(this.tarjetaEditor, tarjetaExistente);
        }
        
        if (!this.tarjetaEditor.activa) {
          await this.desactivarTarjeta();
        }else{
          //llamar al controller para activar la tarjeta
          await this.activarTarjeta();
        }

        console.log('Cerrando la vista...');

        this.editModeOn = false;
        this.$emit('close-dialog');
      }, 

      async desactivarTarjeta() {
      try {
        
        const response = await http.delete(`creditos/deletetarjeta/${this.tarjetaEditor.id}/${this.tarjetaEditor.motivoBaja}`);
        console.log('Llamada al controlador DeleteTarjeta exitosa:', response.data);

      } catch (error) {
        console.error('Error al llamar al controlador DeleteTarjeta:', error);
      
      }
    },

     async activarTarjeta() {
      try {
       
        const response = await http.post(`creditos/activartarjeta/${this.tarjetaEditor.id}/${this.tarjetaEditor.motivoBaja}`);
        console.log('Llamada al controlador exitosa:', response.data);
      
      } catch (error) {
        console.error('Error al llamar al controlador:', error);
        
      }
    },

   


      editar(){
        this.copiarTarjeta(this.tarjetaTokenizada, this.tarjetaEditor);
        this.editModeOn = true;
      },
      eliminar(){
          this.$parent.$parent.$parent.$parent.deleteChild(this.tarjetaTokenizada); // cuando está dentro de una lista hay toda una jerarquía...
      },
      cancelar()
      {
          Vue.$log.debug(this.tarjetaTokenizada)
          if(!this.tarjetaTokenizada.id)
          {
            this.$emit('cancelar-ingreso',this.tarjetaTokenizada.orden)
          }
          this.editModeOn = false;
      },
      updateDatosTarjeta(datos){
      
      Vue.$log.debug(datos);
      //this.model.tarjetaDebito = datos;
      //this.model.tarjetaDebito.altaTarjeta = true;
    },
      
}
}
</script>